import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="sdp-main" data-testid="notFound-component">
      <div
        className="flex align-items-center justify-content-center flex-column w-100 h-100 sdp-p-absolute"
        style={{
          top: 0,
          bottom: 0
        }}
      >
        <h1>404, page or resource not found.</h1>
        <p>
          <Link to="/">&#x2190; go back to SDP Console</Link>
        </p>
      </div>
    </main>
  );
}
